import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    number: 'Bonus 1',
    title: 'The Coach’s Scriptbook',
    desc: 'Master difficult conversations with parents and unmotivated players with professional scripts.',
    image: 'https://cdn.magicpatterns.com/uploads/sV25cS6iZjqVpMmCFesiBj/3d98a92b-a095-489a-9078-cd070011d7ee-mockup.webp'
  }, {
    number: 'Bonus 2',
    title: 'The Warm-up Dictionary',
    desc: 'A library of technical and physical activations to start every session with elite energy.',
    image: 'https://cdn.magicpatterns.com/uploads/cqgHZ3rx5x3sjsseQXTZCp/e385c657-c7bd-4ee4-b180-db64560ffda8-mockup.webp'
  }, {
    number: 'Bonus 3',
    title: 'Circle Efficiency Guide',
    desc: "Professional scoring drills and variations to increase your team's goal conversion rate.",
    image: 'https://cdn.magicpatterns.com/uploads/eSAv1bPYwXJ49AZjo7m9hA/f60244a0-c7fe-4948-a326-cd486e668122-mockup.webp'
  }, {
    number: 'Bonus 4',
    title: 'Defensive Solidity Blueprints',
    desc: 'Step-by-step systems to structure individual and team defense to become hard to beat.',
    image: 'https://cdn.magicpatterns.com/uploads/2Bt5pD1N5umsjBaK9S8tzZ/e01d7199-e4bb-489b-9f02-25e02b7e881a-mockup.webp'
  }, {
    number: 'Bonus 5',
    title: 'The Business of Coaching',
    desc: 'Practical strategies to increase your private session rates and professional value as a coach.',
    image: 'https://cdn.magicpatterns.com/uploads/tNkLDinMzKTzmr51aEJ1g7/d4b9f50a-7dc1-458a-abef-42e6435de29c-mockup.webp'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden pt-[010px] pb-[010px]" data-id="element-44">
      <div className="absolute top-20 right-0 w-96 h-96 bg-pilates-sage/15 rounded-full blur-3xl pointer-events-none" data-id="element-45"></div>
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-pilates-lavender/15 rounded-full blur-3xl pointer-events-none" data-id="element-46"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-47">
        <div className="text-center mb-14" data-id="element-48">
          <div className="bg-pilates-rose/15 text-pilates-rose-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em] flex items-center gap-2 w-fit mx-auto" data-id="element-49">
            <Gift className="w-4 h-4" data-id="element-50" /> 5 LUXURY BONUSES INCLUDED
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-51">
            PLUS... YOU'LL RECEIVE{' '}
            <span className="italic text-pilates-rose" data-id="element-52">
              5 EXCLUSIVE BONUSES FREE
            </span>
          </h2>
          <p className="text-pilates-slate text-base sm:text-lg max-w-2xl mx-auto" data-id="element-53">
            Exclusive resources that will transform your day-to-day — included
            FREE with your pack.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-54">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md border border-pilates-sage/15 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-55">
              <div className="relative mb-5 overflow-hidden rounded-xl bg-gradient-to-br from-pilates-cream to-pilates-soft aspect-square" data-id="element-56">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width="400" height="400" data-id="element-57" />
                <div className="absolute top-3 left-3 bg-pilates-rose text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide shadow-md" data-id="element-58">
                  {bonus.number}
                </div>
                <div className="absolute top-3 right-3 bg-pilates-sage-dark text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider shadow-md" data-id="element-59">
                  🎁 Free
                </div>
              </div>
              <h3 className="font-display font-semibold text-pilates-dark text-lg leading-tight mb-2" data-id="element-60">
                {bonus.title}
              </h3>
              <p className="text-pilates-slate text-sm leading-relaxed" data-id="element-61">
                {bonus.desc}
              </p>
            </div>)}

          {/* Decorative card showing total value */}
          <div className="bg-gradient-to-br from-pilates-sage-dark to-pilates-dark rounded-2xl p-6 shadow-md flex flex-col items-center justify-center text-center text-white" data-id="element-62">
            <Gift className="w-12 h-12 text-pilates-cream mb-3" data-id="element-63" />
            <p className="text-white/80 text-sm uppercase tracking-wider mb-2" data-id="element-64">
              All-inclusive in
            </p>
            <p className="font-display text-3xl font-semibold text-pilates-cream mb-2" data-id="element-65">
              the 6-in-1 Pack
            </p>
            <p className="text-white/75 text-sm leading-relaxed" data-id="element-66">
              The 5 bonuses are FREE with your purchase today.
            </p>
          </div>
        </div>
      </div>
    </section>;
}